import KEYVALUESTORE_ACTIONS from '../../actions/local';
import _ from 'lodash';
//import { ACTION_SEQUENCE_ACTIONS } from '../../actions/sequences';

const initialState = {
  /*sequencer: {
    processing: false,
    results: undefined
  }*/
};

const LocalReducer = (state = initialState, action) => {
  switch (action.type) {
    case KEYVALUESTORE_ACTIONS.KEY_UPDATED: {
      const newState = { ...state };
      _.set(newState, action.payload.key, action.payload.value);
      return newState;
    }
    case KEYVALUESTORE_ACTIONS.KEY_REMOVED: {
      const editState = { ...state };
      _.unset(editState, action.payload.key);
      return editState;
    }
    /*case ACTION_SEQUENCE_ACTIONS.ACTION_SEQUENCE_STARTED: {
      return {
        ...state,
        sequencer: {
          processing: true,
          sequence: action.payload.actionSequence
        }
      };
    }
    case ACTION_SEQUENCE_ACTIONS.ACTION_SEQUENCE_FINISHED: {
      return {
        ...state,
        sequencer: {
          processing: false,
          results: action.payload.results
        }
      };
    }*/
    default:
      return state;
  }
};

export { initialState };

export default LocalReducer;
